import { isEmpty } from 'utils/browserHelper'

export const getLoginFlag = () => {
    const getLoginFlag = JSON.parse(localStorage.getItem('ON_LOGIN_PUSH'))
    if(getLoginFlag){
        return true
    }
    return false
}

export const sendProfileData = (payload) => {
    window.localStorage.setItem('ON_LOGIN_PUSH', true)
    if(window.clevertap && window.clevertap.onUserLogin){
        window.clevertap.onUserLogin.push({ Site: payload})
    }
}

export const loginPush = getLoginFlag()

export const responseMapper = (data)=>{
    try {
        if(!isEmpty(data)){
            if(data.travellers){
                data= {...data,...data.customer}
                data.travellerDetails =  data.travellers
               
            }
            const site = {
                Identity: data.id || data.userId || '',
                Email: data.username || '',
                Phone: `${data.countryCode}${data.mobile}`,
                Gender: data.gender || '',
                'MSG-whatsapp':true,
                'MSG-sms':true,
                'MSG-email': false,                
                "MSG-push": true, 
                
            }
            for (let i = 0; i < data.travellerDetails; i++) {
                const user = data.travellerDetails[i]
                if (user.isRegistered) {
                    site.Name = `${user.personalDetails.firstName} ${user.personalDetails.lastName}`
                    site.DOB = Date(user.personalDetail.dateOfBirth)
                    break
                }
            }
            return site
           
        }
    } catch(e){
       console.log(e)
    }
}

